
<div class="body-wrap boxed-container">
    <main>
        <section class="hero text-center text-light">
    <div class="hero-bg"></div>
    <div class="hero-particles-container">
      <canvas id="hero-particles"></canvas>
    </div>
            <div class="container-sm">
                <div class="hero-inner">
        <div class="hero-copy">
                      <h1 class="hero-title mt-0">Yard Hostle</h1>
                      <p class="hero-paragraph">Manage your yard and trailers with our applications. Stay in control in real time, sync data seamlessly across devices, and receive insightful reports via email. Streamline your operations and boost productivity with our intuitive inventory management solution.</p>
                      <div class="hero-cta">
            <a class="button button-primary button-wide-mobile" routerLink="/register" *ngIf="!isLoggedIn">Create account</a>
          </div>
        </div>
        <div class="mockup-container">
          <div class="mockup-bg">
            <img src="assets/dist/images/iphone-hero-bg.svg" alt="iPhone illustration">
          </div>
          <img class="device-mockup" src="assets/dist/images/logo.png" style="border-radius: 50%;" alt="iPhone Hero">
        </div>
                </div>
            </div>
        </section>
  
  <section class="features-extended section">
            <div class="features-extended-inner section-inner">
      <div class="features-extended-wrap">
        <div class="container">
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img src="assets/dist/images/iphone-feature-bg-01.svg" alt="iPhone Feature 01 illustration">
              </div>
              <img class="device-mockup is-revealing" src="assets/dist/images/home_pic.png" alt="iPhone Feature 01">
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">Real time updates</h3>
              <p class="m-0">Stay in the loop with real-time updates on all your shipments, ensuring you're always informed.</p>
              <p class="m-0">Never miss a beat with our live update feature, providing instant notifications on shipment status</p>
            </div>
          </div>
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img src="assets/dist/images/iphone-feature-bg-02.svg" alt="iPhone Feature 02 illustration">
              </div>
              <img class="device-mockup is-revealing" src="assets/dist/images/phone-screen-shot.png" alt="iPhone Feature 02">
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">Driver portal</h3>
              <p class="m-0">Driver dedicated portal, offering seamless communication and real-time routing.</p>
              <p class="m-0">Driver portal can be access via webapp or <a href="https://play.google.com/store/apps/details?id=com.yardhostle&pcampaignid=web_share">android</a></p>
            </div>
          </div>
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img src="assets/dist/images/iphone-feature-bg-03.jpg" alt="iPhone Feature 03 illustration">
              </div>
              <img class="device-mockup is-revealing" src="assets/dist/images/web-screen-shot.png" alt="iPhone Feature 03">
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">Shipper portal</h3>
              <p class="m-0">Streamline your shipping process with our intuitive shipper portal, designed for efficiency and ease.</p>
              <p class="m-0">Manage all your yard effortlessly with our user-friendly shipper portal. All the essential in one place.</p>
            </div>
          </div>
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img src="assets/dist/images/iphone-feature-bg-04.svg" alt="iPhone Feature 04 illustration">
              </div>
              <img class="device-mockup is-revealing" src="https://cdn-icons-png.freepik.com/512/1/1437.png?ga=GA1.1.1833807595.1720263526" alt="iPhone Feature 04">
              
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">Significantly reduced price.</h3>
              <p class="m-0">Enjoy a significantly reduced price compared to other providers. See prices <a href="https://yardhostle.com/pricing">here</a></p>
              <p class="m-0">Start now! 30 day free trial! no credit card required cancel any time.</p>
            </div>
          </div>
        </div>
      </div>
            </div>
        </section>
    </main>
  
  
  </div>
